import React, { useCallback } from 'react';
import queryString from 'query-string';
import { Redirect, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';

import SetNewPasswordForm from '../../components/SetNewPasswordForm';

import { usePasswordActions } from '../../hooks';
import { SetNewPasswordInput } from '../../types/Auth';

const SetNewPasswordPageContainer = () => {
  const location = useLocation();

  const { token } = queryString.parse(location.search) as { token?: string };
  const { onSetNewPassword, setNewPasswordLoading, setNewPasswordError } = usePasswordActions();

  const handleSetNewPassword = useCallback(
    (input: SetNewPasswordInput) => {
      if (token) {
        onSetNewPassword(token, input, () => {
          window.location.href = '/login';
        });
      }
    },
    [token, onSetNewPassword]
  );

  if (!token) {
    return <Redirect to="/login" />;
  }

  return (
    <Box display="flex" width="100%" justifyContent="center">
      <Box width={{ xs: '100%', md: 400 }} maxWidth={{ xs: 400, md: undefined }} p={2} my={3} mt={24}>
        <SetNewPasswordForm onSubmit={handleSetNewPassword} isSubmitting={setNewPasswordLoading} submitError={setNewPasswordError} />
      </Box>
    </Box>
  );
};

export default SetNewPasswordPageContainer;
